import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from "rxjs";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import { AdditionalCapacityInfoModel } from "../../../models/venues/additional-capacity-info.model";
import * as moment from "moment/moment";
import { VenueService } from "../../../services/venues/venue.service";
import { CreateCapacityForVenuesComponent } from "../create-capacity-for-venues/create-capacity-for-venues.component";
import { CreateOrEditCapacityModel } from "../../../models/tables/create-or-edit-capacity.model";

@Component({
  selector: 'app-add-capacity-template-form',
  templateUrl: './add-capacity-template-form.component.html',
  styleUrls: ['./add-capacity-template-form.component.scss']
})
export class AddCapacityTemplateFormComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public errorModel: { [k: string]: any } = {};
  public spinner: boolean = false;
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  public dateRange: Date[] = [new Date()];
  @ViewChild('rangeCalendar') dateRangePickerControl: any;
  public fromTime: Date = moment(new Date()).startOf('day').toDate();
  public toTime: Date = moment(new Date()).startOf('day').toDate();
  public isTouch: boolean;
  public editEnabled: boolean = false;
  public venueId: string;
  public capacityConfig: CreateOrEditCapacityModel;
  public capacityTemplateModel: AdditionalCapacityInfoModel = new AdditionalCapacityInfoModel();
  public fromAddVenue: boolean = false;
  //#endregion

  //#region Constructor
  constructor(private ref: DynamicDialogRef,
              private config: DynamicDialogConfig,
              public translate: TranslateService,
              public venueService: VenueService,
              public dialogService: DialogService,
              public messageService: MessageService) {
    this.isTouch = window.innerWidth < 480 || window.innerHeight < 835;
    window.addEventListener('resize', this.handleResize.bind(this));
    if (this.config.data != undefined && this.config.data.id) {
      this.venueId = this.config.data.id;
    }

    if (this.config.data != undefined && this.config.data.fromAddVenue) {
      this.fromAddVenue = this.config.data.fromAddVenue;
    }

    if (this.config.data != undefined && this.config.data.capacityConfig) {
      this.editEnabled = true;
      this.capacityConfig = this.config.data.capacityConfig;

      this.capacityTemplateModel.name = this.config.data.capacityConfig.name;
      this.capacityTemplateModel.venueId = this.config.data.capacityConfig.venueId;

      if (this.config.data.capacityConfig.startDate && this.config.data.capacityConfig.endDate) {
        this.dateRange = [new Date(this.capacityConfig.startDate), new Date(this.capacityConfig.endDate)];
      }

      if (this.config.data.capacityConfig.startTime && this.config.data.capacityConfig.endTime) {
        this.fromTime = moment(this.capacityConfig.startTime, 'HH:mm').toDate();
        this.toTime =  moment(this.capacityConfig.endTime, 'HH:mm').toDate();
      }
    }
  }

  public ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  public editCapacityTemplateDates(model: AdditionalCapacityInfoModel) {
    this.errorModel = {};

    if (!model.name || model.name.trim() == "") {
      this.errorModel['Name'] = this.requiredFieldErrorMessage;
    }

    if (this.dateRange.length < 2 || !this.dateRange[1]) {
      this.errorModel['DateRange'] = this.requiredFieldErrorMessage;
    }

    if (Object.keys(this.errorModel).length === 0) {
      this.capacityConfig.startDate = moment(this.dateRange[0]).format('yyyy-MM-DDTHH:mm:ss');
      this.capacityConfig.endDate = moment(this.dateRange[1]).format('yyyy-MM-DDTHH:mm:ss');
      this.capacityConfig.startTime = moment(this.fromTime).format('HH:mm');
      this.capacityConfig.endTime = moment(this.toTime).format('HH:mm');
      this.capacityConfig.name = model.name;

      this.venueService.updateCapacity(this.capacityConfig)
        .subscribe({
          next: (response) => {
            this.ref.close(this.capacityConfig);
          },
          error: errorResponse => {
            this.ref.close(errorResponse);
          }
        });
    }
  }

  public addCapacityTemplate(model: AdditionalCapacityInfoModel) {
    this.errorModel = {};

    if (!model.name || model.name.trim() == "") {
      this.errorModel['Name'] = this.requiredFieldErrorMessage;
    }

    if (this.dateRange.length < 2 || !this.dateRange[1]) {
      this.errorModel['DateRange'] = this.requiredFieldErrorMessage;
    }

    if (Object.keys(this.errorModel).length === 0) {
      model.fromDate = moment(this.dateRange[0]).format('yyyy-MM-DDTHH:mm:ss');
      model.toDate = moment(this.dateRange[1]).format('yyyy-MM-DDTHH:mm:ss');
      model.fromTime = moment(this.fromTime).format('HH:mm');
      model.toTime = moment(this.toTime).format('HH:mm');

      const ref = this.dialogService.open(CreateCapacityForVenuesComponent, {
        data: {
          id: this.venueId,
          name: model.name,
          startDate: model.fromDate,
          endDate: model.toDate,
          startTime: model.fromTime,
          endTime: model.toTime,
          default: false,
          fromAddVenue: this.fromAddVenue
        },
        width: '1000px',
        styleClass: '',
        header: model.name
      });
      ref.onClose.subscribe((item: any) => {
        if (item) {
          this.ref.close(item);
        }
      });
    }
  }

  public isRangeDate(date: any, index: number, both: boolean = false): boolean {
    const selected = this.dateRangePickerControl.value && this.dateRangePickerControl.value[index] ? this.dateRangePickerControl.value[index] : null;
    if (selected) {
      const equals = date.day === selected.getDate() && date.year === selected.getFullYear() && date.month === selected.getMonth();

      if (both && equals) {
        return !this.dateRangePickerControl.value[1];
      }

      return equals;
    }
    return false;
  }

  public cancel(): void {
    this.ref.close(false);
  }

  public handleResize(): void {
    this.dateRangePickerControl.toggle();
    this.isTouch = window.innerWidth < 480 || window.innerHeight < 835;
    this.dateRangePickerControl.touchUI = this.isTouch;
  }
  //#endregion
}
